const React = require('react')
const { BlockchainNavIcon, LookupNavIcon, ToolNavIcon } = require('@assets/icons')
const { useNetworkConfig } = require('@contexts')
const { CustomDropdown } = require('@components')
const { blockchainOptions, lookupOptions, toolsOptions, ecoOptions } = require('./dropdownOptions.header')

require('@styles/layouts/header/dropdown.header.css')

const HeaderDropdown = props => {
    const { network } = useNetworkConfig()

    const isBlockchain_1 = network.data.type === 'Ethereum 1.0'
    const isBlockchain_2 = network.data.type === 'Ethereum 2.0'

    const getNavIcon = title => {
        switch (title.toLowerCase()) {
            case 'blockchain':
                return <BlockchainNavIcon color='currentColor' />
            case 'lookup':
                return <LookupNavIcon color='#ffffff' />
            case 'tools':
                return <ToolNavIcon color='currentColor' />
            // case 'eco':
            //     return <EcoNavIcon color='#d2d2d2' />
            default:
                return <BlockchainNavIcon color='currentColor' />
        }
    }

    const getOptions = title => {
        switch (title.toLowerCase()) {
            case 'blockchain':
                const options = isBlockchain_1
                    ? blockchainOptions
                    : blockchainOptions.concat([
                          { type: 'divider' },
                          { name: 'Epochs', value: 'epochs' },
                          { name: 'Slots', value: 'slots' },
                          { type: 'divider' },
                          { name: 'Validators', value: 'validators' }
                      ])

                return options
            case 'lookup':
                return lookupOptions
            case 'tools':
                return toolsOptions
            // case 'eco':
            //     return ecoOptions
            default:
                return blockchainOptions
        }
    }

    const handleClick = value => {
        if (value.startsWith('http')) {
            window.open(value, '_blank')
        } else {
            window.location.href = `/${network.data.shortName}/${value}`
        }
    }

    return (
        <div className='header-options-dropdown'>
            <CustomDropdown
                listItems={getOptions(props.title)}
                currentItem={{
                    title: (
                        <a>
                            {getNavIcon(props.title)}
                            &nbsp; {props.title}
                        </a>
                    )
                }}
                handleClick={handleClick}
            />
        </div>
    )
}

module.exports = { HeaderDropdown }
